import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, subtitle, children }) {
    return (
        <section className="relative overflow-hidden border-b border-border">
            <div className="pointer-events-none absolute inset-0 grain opacity-[0.04]" aria-hidden />
            <div className="pointer-events-none absolute -right-40 -top-40 h-96 w-96 rounded-full bg-gr-accent/20 blur-3xl" aria-hidden />
            <div className="container-gr py-16 lg:py-24">
                {eyebrow && (
                    <motion.p
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="font-mono text-xs uppercase tracking-[0.2em] text-gr-accent"
                    >
                        {eyebrow}
                    </motion.p>
                )}
                <motion.h1
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.05 }}
                    className="mt-4 max-w-3xl text-balance text-4xl leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-6xl"
                >
                    {title}
                </motion.h1>
                {subtitle && (
                    <motion.p
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.12 }}
                        className="mt-6 max-w-2xl text-lg leading-relaxed text-muted-foreground"
                    >
                        {subtitle}
                    </motion.p>
                )}
                {children && <div className="mt-8">{children}</div>}
            </div>
        </section>
    );
}
